import { useContext } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { AiSuggestedSearchCriteria } from './AiSuggestedSearchCriteria';
import AiSuggestedResults from './AiSuggestedResults';
import LoadingSpinner from '../../../library/SimpleControls/LoadingSpinner';

const AiSuggestedLayout = () => {
    const { state } = useContext(SmartContext);

    return (
        <div className="main flex-1">
            {!state?.data && <LoadingSpinner />}
            {state?.data && (
                <div className="">
                    <div className="mb-4">
                        <div className="">
                            <div className="">
                                <div className="ai_suggested_content">
                                    <div className="ActiveListings_present">
                                        <AiSuggestedSearchCriteria />
                                        <AiSuggestedResults />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AiSuggestedLayout;
